const track = event => {
  const { category, action, label, property, value, contexts, interactive } = event;

  const interaction = interactive === undefined || !!interactive;

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: interaction ? 'hipagesInteractiveEvent' : 'hipagesNonInteractiveEvent',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventProperty: property,
    eventValue: value,
    eventContexts: contexts
  });
};

export default () => next => action => {
  if (action.type && action.meta && action.meta.event) {
    track(action.meta.event);
  }

  return next(action);
};
